



























import Vue from 'vue';
import { ExplorerSorter } from './ExplorerSorter';

export default Vue.extend({
  props: {
    sorter: {
      type: Object as () => ExplorerSorter<any>,
    },
  },
});
